export const START_LOADING = 'START_LOADING';
export const FINISH_LOADING = 'FINISH_LOADING';
export const SET_LOADING_TEXT = 'SET_LOADING_TEXT';
export const SET_MESSAGE = 'SET_MESSAGE';
export const SET_MS_MESSAGE = 'SET_MS_MESSAGE';
export const REVOKE_MESSAGE = 'REVOKE_MESSAGE';
export const CLEAR_MS_MESSAGE = 'CLEAR_MS_MESSAGE';
export const NO_ACTION = 'NO_ACTION';
export const GET_FOOTER = 'GET_FOOTER';
export const GET_HEADER = 'GET_HEADER';
export const GET_HEADER_FOOTER = 'GET_HEADER_FOOTER';
export const UPDATE_TRENDING_SEARCH = 'UPDATE_TRENDING_SEARCH';
export const UPDATE_SEARCH_PROMOTIONS = 'UPDATE_SEARCH_PROMOTIONS';
export const UPDATE_SEARCH_RESULTS = 'UPDATE_SEARCH_RESULTS';
export const UPDATE_LAST_SEARCH = 'UPDATE_LAST_SEARCH';
export const UPDATE_COMMERCE_SEARCH_SUGGESTIONS = 'UPDATE_COMMERCE_SEARCH_SUGGESTIONS';
export const UPDATE_SEARCH_QUERY = 'UPDATE_SEARCH_QUERY';
export const UPDATE_SELECTED_CATEGORY = 'UPDATE_SELECTED_CATEGORY';
export const UPDATE_SCREEN_NAME = 'UPDATE_SCREEN_NAME';
export const UPDATE_PREVIOUS_SCREEN_NAME = 'UPDATE_PREVIOUS_SCREEN_NAME';
export const UPDATE_CART = 'UPDATE_CART';
export const CLEAR = 'CLEAR';
export const UPDATE_CART_DETAILS = 'UPDATE_CART_DETAILS';
export const CREATE_CART = 'CREATE_CART';
export const GET_CART_DETAILS = 'GET_CART_DETAILS';
export const DELETE_CART = 'DELETE_CART';
export const CLEAR_ORDER = 'CLEAR_ORDER';
export const UPDATE_CUSTOMER_DETAILS = 'UPDATE_CUSTOMER_DETAILS';
export const UPDATE_CUSTOMER_IDENTIFICATION = 'UPDATE_CUSTOMER_IDENTIFICATION';
export const CUSTOMER_ACCOUNT_LIST = 'CUSTOMER_ACCOUNT_LIST';
export const BCC_CHECK_DETAILS = 'BCC_CHECK_DETAILS';
export const CLEAR_CUSTOMER = 'CLEAR_CUSTOMER';
export const GET_FACE_ID_DETAILS = 'GET_FACE_ID_DETAILS';
export const UPDATE_CUSTOMER_PERSONAL_DETAILS = 'UPDATE_CUSTOMER_PERSONAL_DETAILS';
export const GET_ORDER_SUMMARY = 'GET_ORDER_SUMMARY';
export const GET_ORDER_DETAILS = 'GET_ORDER_DETAILS';
export const GET_LD_TNC = 'GET_LD_TNC';
export const UPDATE_BIZHUB_CUSTOMER_ACCESSIBLE_COMPANY = 'UPDATE_BIZHUB_CUSTOMER_ACCESSIBLE_COMPANY';
export const UPDATE_BIZHUB_CUSTOMER_ACCOUNT_LIST = 'UPDATE_BIZHUB_CUSTOMER_ACCOUNT_LIST';
export const UPDATE_BIZHUB_CUSTOMER_DETAILS = 'UPDATE_BIZHUB_CUSTOMER_DETAILS';
export const UPDATE_MBH_USER_INFO = 'UPDATE_MBH_USER_INFO';


